import create from "zustand"
import { persist } from "zustand/middleware"
import { getProfile } from "../../networks/User";

const persistConfig = {
  name: "user-storage"
};

const userStore = create(
  persist((set, get) => {

    const initState = {
      accessToken: null,
      profile: null
    }

    const sendAccessTokenToNativeAction = () => {
      let accessToken = get().accessToken;
      if (accessToken) {
        window?.Native?.saveAccessToken?.(accessToken);
        window?.webkit?.messageHandlers?.saveAccessToken?.postMessage?.(accessToken);
      }
    }

    const setAccessTokenAction = (accessToken) => {
      set({ 
        accessToken
      })
      sendAccessTokenToNativeAction();
    }

    const setProfileAction = (profile) => {
      set({ 
        profile
      })
    }

    const clearAllAction = () => {
      set({
        ...initState
      })
      sendLogoutEventToNativeAction();
    }

    const sendLogoutEventToNativeAction = () => {
      window?.Native?.logout?.()
      window?.webkit?.messageHandlers?.logout?.postMessage?.({});
    }

    const getProfileAction = async () => {
      try {
        set({ isLoading: true })
        const response = await getProfile()
        set({ 
          profile: response.data
        })
      } catch (error) {
        set({ isLoading: false })
      }
    }

    return {
      ...initState,
      setAccessToken: setAccessTokenAction,
      setProfile: setProfileAction,
      getProfile: getProfileAction,
      sendAccessTokenToNative: sendAccessTokenToNativeAction,
      clearAll: clearAllAction,
      sendLogoutEventToNative: sendLogoutEventToNativeAction,
    }
  }, persistConfig
))

export default userStore;